import TableRow from "@mui/material/TableRow";
import TableCell from '../../../Utilities/TruncatedTableCell';
import SurveyTableViewModel from "../../ViewModels/SurveyTableViewModel";
import Checkbox from '@mui/material/Checkbox';
import { useContext } from "react";
import { SessionContext } from "../../../Contexts/SessionContext";
import { useSearchParams } from "react-router-dom";
import { SurveyViewModel } from "../../../Contexts/SessionState";
import { surveyRefsMatch } from "../../TripRateSurveyRefs";
import { surveySelectionColumnSx } from "./SurveySelectionTableStyles";

type SurveyMode = 'latest' | 'busiest' | 'all';

interface IProps {
    row: SurveyTableViewModel;
    setDeselectionOpen: (id: string) => void;
    mode: SurveyMode;
    setSelectedRowId: (row: SurveyTableViewModel) => void;
    multiDeselect?: boolean;
}

export default function SurveySelectionRow({ row, setDeselectionOpen, mode, setSelectedRowId, multiDeselect }: IProps) {
    const { sessionState, updateSessionState } = useContext(SessionContext);

    const [searchParams] = useSearchParams();
    const stopRefresh = searchParams.get("fromSession") === "true" || searchParams.get("fromResults") === "true";

    var s: SurveyViewModel | undefined;

    if (stopRefresh) {
        s = sessionState.selectedSitesAndSurveys.find(x => surveyRefsMatch(x.surveyRef, row.surveyId));

        if (s?.siteActive === false) {
            return <></>;
        }

    } else {
        s = sessionState.selectedSitesAndSurveys.find(x => surveyRefsMatch(x.surveyRef, row.surveyId));
    }
   
    const checked = s?.surveyActive;
    const reason = s?.reasonForSurveyRemoval;
    const isDisabled = !s?.siteActive || (mode === 'latest' && s?.latestSurveyId !== row.surveyId) || (mode === 'busiest' && s?.busiestSurveyId !== row.surveyId);
    const pendingDeselect = s?.surveyPendingDeselect ?? false;

    const oncheckboxchange = (e: any) => {
        e.stopPropagation();

        if (checked && setDeselectionOpen) {
            setDeselectionOpen(row.siteId);


            if (multiDeselect) {

                const updatedSites = sessionState.selectedSitesAndSurveys.map(site =>
                    surveyRefsMatch(site.surveyRef, row.surveyId)
                        ? { ...site, surveyPendingDeselect: !site.surveyPendingDeselect }
                        : site
                );

                updateSessionState({ selectedSitesAndSurveys: updatedSites });
            }

            return;
        }

        if (multiDeselect) {
            return;
        }

        const updatedSites = sessionState.selectedSitesAndSurveys.map(site =>
            surveyRefsMatch(site.surveyRef, row.surveyId)
                ? {
                    ...site,
                    reasonForSurveyRemoval: "",
                    reasonForSiteRemoval: "",
                    surveyActive: !site.surveyActive,
                    pendingDeselect: false
                }
                : site
        );

        updateSessionState({ selectedSitesAndSurveys: updatedSites });
    };

    return (
        <TableRow onClick={() => setSelectedRowId(row)}
            style={{ cursor: "pointer" }}>
            <TableCell onClick={oncheckboxchange} align="center" sx={surveySelectionColumnSx.include}>
                <Checkbox
                    checked={checked}
                    disabled={isDisabled || multiDeselect}
                    style={{ padding: '0px' }}
                />
                {(multiDeselect && checked) &&
                    <Checkbox checked={!pendingDeselect} style={{ padding: '0px' }} />
                }
            </TableCell>
            <TableCell sx={surveySelectionColumnSx.reference}>{row.surveyId.split('|')[0]}</TableCell>
            <TableCell sx={surveySelectionColumnSx.date}>{new Date(row.date?.toString() ?? '')?.toLocaleDateString("en-GB")}</TableCell>
            <TableCell sx={surveySelectionColumnSx.dayOfWeek}>{row.dayOfWeek}</TableCell>
            <TableCell sx={surveySelectionColumnSx.surveyType}>{row.type}</TableCell>
            <TableCell sx={surveySelectionColumnSx.locationType}>{row.description.split('(')[0]}</TableCell>
            <TableCell sx={surveySelectionColumnSx.town}>{row.town}</TableCell>
            <TableCell sx={surveySelectionColumnSx.reason}>{reason}</TableCell>
        </TableRow>
    );
}
